export default __webpack_public_path__ + "static/bruce3-bf7f6901f71c56d831c70bc1aa6dc948.png";